import React, { useMemo } from 'react';
import styled from 'styled-components';
import { standardDateTime } from '@ibinder/common-utils';

import { Flexbox, TableDocumentList } from '@ibinder/common-frontend';
import { TableWrapper } from '../../../../components/PrintProviders/styles/common';
import { check } from '@ibinder/common-icons';
import { IconWrapper } from './ListContainer/ListDocument/styles.index';

const Container = styled.div`
  animation: identifier 350ms;
  margin-bottom: 1rem;
  @keyframes identifier {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 80px;
    }
  }
`;

const TruncatedSpan = styled.p`
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const EmailMessagesList = ({ sentEmailMessages, loading }) => {
  if (loading) {
    return <div>Loading...</div>;
  }

  interface SentEmailMessagesData {
    id: string;
    lastActivityDate: string;
    delivered: boolean;
    status?: string;
    subject?: string;
    recipientEmail: string;
  }

  const headers = [
    {
      id: '0',
      name: 'Date',
      propName: 'lastActivityDate',
      Cell: ({ cell }) =>
        cell.value && typeof cell.value === 'string'
          ? standardDateTime(cell.value)
          : ''
    },
    {
      id: '1',
      name: 'Delivered',
      propName: 'delivered',
      Cell: ({ cell }) => cell.value && <IconWrapper>{check}</IconWrapper>
    },
    {
      id: '2',
      name: 'Status',
      propName: 'status',
      Cell: ({ cell }) => cell.value
    },
    {
      id: '3',
      name: 'Subject',
      propName: 'subject',
      Cell: ({ cell }) => {
        return (
          <Flexbox flexDirection={'row'} alignItems={'center'}>
            <TruncatedSpan>{cell.value ?? ''}</TruncatedSpan>
          </Flexbox>
        );
      }
    },
    {
      id: '4',
      name: 'Recipient email',
      propName: 'recipientEmail',
      Cell: ({ cell }) => cell.value
    }
  ];

  const getTableData = (
    headers: Record<string, any>[],
    data: SentEmailMessagesData[]
  ): any[] => {
    const getValueByPropName = (
      row: any,
      propName: string
    ): string | boolean => {
      switch (propName) {
        case 'id':
        case 'recipientEmail':
        case 'subject':
        case 'status':
        case 'delivered':
        case 'lastActivityDate':
          return row[propName];
        default:
          return '';
      }
    };

    return data?.map((row) => ({
      metadata: headers.map((header) => ({
        metadataElementId: header.id,
        value: getValueByPropName(row, header.propName),
        sortValue: getValueByPropName(row, header.propName)
      }))
    }));
  };

  const tableData = useMemo(
    () => getTableData(headers, sentEmailMessages?.get),
    [headers, sentEmailMessages]
  );

  return (
    <Container>
      {sentEmailMessages && (
        <TableWrapper borderTop>
          <TableDocumentList
            setSelectedIds={null}
            selectedIds={[]}
            headers={headers}
            documentQuery={tableData}
            sortBy={[]}
            onSort={undefined}
            metadataElements={[]}
            rowAction={undefined}
          />
        </TableWrapper>
      )}
    </Container>
  );
};

export default EmailMessagesList;
